module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Shield-protected-6c16417088d5e9fc464a791bceadad5c.svg";